import React from 'react';
import tw from 'twin.macro';

interface KeyPointProps {
  index: string;
  title: string;
  content: string;
}

const IndexContainer = tw.div`flex items-center pt-4 pb-2 md:pt-8 md:pb-4 text-xl md:text-3xl text-black font-bold`;
const Index = tw.div`flex items-center justify-center w-8 md:w-12 h-8 md:h-12 mr-3 text-white bg-black select-none`;
const ContentContainer = tw.div`pl-8 md:pl-12 ml-3 text-gray-600 text-base md:text-lg font-light`;

const KeyPoint: React.FC<KeyPointProps> = (props) => {
  return (
    <>
      <IndexContainer>
        <Index>{props.index}</Index>
        {props.title}
      </IndexContainer>
      <ContentContainer>{props.content}</ContentContainer>
    </>
  );
};

export default KeyPoint;
